/**
 * In-memory store for auth tokens (Cognito idToken, BackOffice serviceToken).
 * Avoids localStorage to reduce XSS exposure (OBD-911).
 */

const store: { idToken: string | null; serviceToken: string | null } = {
    idToken: null,
    serviceToken: null
};

export type AuthTokenKey = 'idToken' | 'serviceToken';

export const authTokenStore = {
    getToken(key: AuthTokenKey): string | null {
        return store[key];
    },

    setToken(key: AuthTokenKey, value: string | null): void {
        store[key] = value;
    },

    clearToken(key: AuthTokenKey): void {
        store[key] = null;
    },

    clear(): void {
        store.idToken = null;
        store.serviceToken = null;
    }
};
